module.exports = __webpack_public_path__ + "fonts/CrimsonText-SemiBoldItalic.f5c6704d.ttf";